export const BRAND_CREATE_RESET = 'BRAND_CREATE_RESET'
export const BRAND_CREATE_SET_CREATED = 'BRAND_CREATE_SET_CREATED'
export const BRAND_CREATE_SET_ERROR = 'BRAND_CREATE_SET_ERROR'
export const BRAND_CREATE_SET_VIOLATIONS = 'BRAND_CREATE_SET_VIOLATIONS'
export const BRAND_CREATE_TOGGLE_LOADING = 'BRAND_CREATE_TOGGLE_LOADING'
